module.exports = "https://coursera_assets.s3.amazonaws.com/images/0666d4d0c3ae70a1757d25a755e7f873.svg";